export default function News() {
  const newsItems = [
    {
      title: '新サービス「ブランドストーリーイラストレーション」を開始',
      category: 'サービス',
      date: '2024年3月15日',
      readTime: '5分',
      image: 'https://readdy.ai/api/search-image?query=Brand%20storytelling%20illustration%20concept%2C%20narrative%20visual%20design%2C%20creative%20process%20workspace%2C%20modern%20design%20studio%2C%20professional%20illustration%20tools%2C%20artistic%20atmosphere%2C%20warm%20lighting%2C%20simple%20background&width=600&height=400&seq=news001&orientation=landscape',
      excerpt: '企業のブランドストーリーを一連のイラストレーションで表現する新サービスを開始しました。創業の想い、ビジョン、価値観を視覚化し、顧客との感情的なつながりを強化します。'
    },
    {
      title: 'デザインアワード2024で金賞を受賞',
      category: '受賞',
      date: '2024年3月8日',
      readTime: '3分',
      image: 'https://readdy.ai/api/search-image?query=Design%20award%20trophy%20and%20certificate%2C%20professional%20achievement%20recognition%2C%20elegant%20presentation%2C%20gold%20medal%2C%20prestigious%20award%20ceremony%2C%20sophisticated%20lighting%2C%20simple%20background&width=600&height=400&seq=news002&orientation=landscape',
      excerpt: '食品ブランドのパッケージデザインプロジェクトが、Japan Design Award 2024のパッケージ部門で金賞を受賞しました。審査員からは「独創性と商業性の完璧なバランス」と高い評価をいただきました。'
    },
    {
      title: 'イラストレーション制作の舞台裏を公開',
      category: 'ブログ',
      date: '2024年3月1日',
      readTime: '8分',
      image: 'https://readdy.ai/api/search-image?query=Illustration%20creation%20process%20behind%20the%20scenes%2C%20artist%20working%20on%20digital%20tablet%2C%20creative%20workflow%2C%20sketches%20and%20drafts%2C%20professional%20studio%20environment%2C%20artistic%20tools%2C%20simple%20background&width=600&height=400&seq=news003&orientation=landscape',
      excerpt: 'クライアント様からよくご質問いただく「イラストレーションはどのように作られるのか」について、実際のプロジェクトを例に詳しく解説します。ヒアリングから納品までの全工程をご紹介。'
    },
    {
      title: 'オンライン相談サービスを拡充',
      category: 'お知らせ',
      date: '2024年2月20日',
      readTime: '4分',
      image: 'https://readdy.ai/api/search-image?query=Online%20consultation%20video%20call%2C%20professional%20remote%20meeting%2C%20digital%20communication%2C%20modern%20workspace%2C%20laptop%20screen%20with%20video%20conference%2C%20friendly%20atmosphere%2C%20simple%20background&width=600&height=400&seq=news004&orientation=landscape',
      excerpt: '全国どこからでもご相談いただけるオンライン相談サービスを拡充しました。Zoom、Google Meet、Microsoft Teamsに対応し、初回相談は無料です。お気軽にお問い合わせください。'
    },
    {
      title: '春の新作イラストコレクションを公開',
      category: 'ポートフォリオ',
      date: '2024年2月15日',
      readTime: '6分',
      image: 'https://readdy.ai/api/search-image?query=Spring%20season%20illustration%20collection%2C%20cherry%20blossom%20artwork%2C%20fresh%20colorful%20designs%2C%20seasonal%20visual%20art%2C%20nature-inspired%20illustrations%2C%20vibrant%20spring%20colors%2C%20artistic%20composition%2C%20simple%20background&width=600&height=400&seq=news005&orientation=landscape',
      excerpt: '春をテーマにした新作イラストコレクションを公開しました。桜、新緑、春の風景など、季節感あふれる作品を多数ご用意。商業利用可能なライセンス販売も開始しています。'
    },
    {
      title: 'クライアント事例インタビュー：ナチュラルフーズ様',
      category: '事例',
      date: '2024年2月10日',
      readTime: '10分',
      image: 'https://readdy.ai/api/search-image?query=Client%20interview%20business%20meeting%2C%20professional%20discussion%2C%20corporate%20collaboration%2C%20office%20setting%2C%20friendly%20conversation%2C%20natural%20lighting%2C%20modern%20workspace%2C%20simple%20background&width=600&height=400&seq=news006&orientation=landscape',
      excerpt: 'パッケージリニューアルプロジェクトでご協力いただいた株式会社ナチュラルフーズ様に、プロジェクトの成果と今後の展望についてお話を伺いました。売上150%増の成功事例をご紹介。'
    }
  ];

  return (
    <section id="news" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              ニュース & ブログ
            </h2>
            <p className="text-lg text-gray-600">
              最新情報、制作事例、業界トレンドなどを定期的に発信しています
            </p>
          </div>
          <a href="#" className="flex items-center gap-2 text-base font-medium text-gray-900 hover:text-rose-600 transition-colors whitespace-nowrap cursor-pointer">
            すべて見る
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsItems.map((item, index) => (
            <article 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-white text-xs font-medium text-gray-900 rounded-full shadow-md">
                    {item.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight group-hover:text-rose-600 transition-colors" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  {item.title}
                </h3>
                
                <p className="text-sm text-gray-600 leading-relaxed mb-4">
                  {item.excerpt}
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-4 text-xs text-gray-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {item.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {item.readTime}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-sm font-medium text-gray-900 group-hover:text-rose-600 transition-colors">
                    続きを読む
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}